import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'
import { MainButton, CancelButton, WarningButton } from 'components/button'

import styles from './notification_box.scss'

const actionButtonTypeEnum = {
	MAIN: 0,
	WARNING: 1,
}

class NotificationBox extends PureComponent {

	render() {
		return (
			<div styleName={classNames({
				wrapper: true,
				'wrapper--no-icon': !(this.props.icon),
			})}>
				{
					this.props.icon &&
						<div styleName={classNames({
							icon: true,
							[`icon--${this.props.iconBackground}`]: true,
						})}>
							{this.props.icon}
						</div>
				}
				<div styleName='content'>
					<div styleName='title'>
						{this.props.title}
					</div>
					<div styleName='text'>
						{this.props.text}
					</div>
					{ (this.props.btOne || this.props.btTwo) &&
						<div styleName={classNames({
							'btn-bar': true,
							'single-button': !(this.props.btOne && this.props.btTwo),
						})}>
							{ this.props.btOne &&
								<div styleName='btn-bar-button'>
									<CancelButton
										autoFocus={true}
										focus={true}
										tabIndex={100}
										onClick={this.props.actionOne}
										onTouchEnd={e => {
											e.preventDefault()
											this.props.actionOne()
										}}
									>
										{this.props.btOne}
									</CancelButton>
								</div>
							}
							{ this.props.btTwo &&
								<div styleName='btn-bar-button'>
									{ this.props.actionButtonType === 1
										? (
											<WarningButton focus={true} tabIndex={101} onClick={this.props.actionTwo}>
												{this.props.btTwo}
											</WarningButton>
										)
										:
										(
											<MainButton focus={true} tabIndex={101} onClick={this.props.actionTwo}>
												{this.props.btTwo}
											</MainButton>
										)
									}
								</div>
							}
						</div>
					}
				</div>
			</div>
		)
	}

}

NotificationBox.defaultProps = {
	icon: null,
	title: null,
	text: null,
	btOne: '',
	actionOne: () => {},
	btTwo: '',
	actionTwo: () => {},
	actionButtonType: actionButtonTypeEnum.MAIN,
	iconBackground: 'blue',
}

NotificationBox.propTypes = {
	icon: PropTypes.object,
	title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	text: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	btOne: PropTypes.string,
	actionOne: PropTypes.func,
	btTwo: PropTypes.string,
	actionTwo: PropTypes.func,
	actionButtonType: PropTypes.oneOf(Object.values(actionButtonTypeEnum)),
	iconBackground: PropTypes.oneOf(['blue', 'transparent']),
}


export default CSSModules(NotificationBox, styles, {allowMultiple: true})

export {
	actionButtonTypeEnum,
}
